import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
  headerData: ["ID", "Name", "Image"],
};

const skillsSlice = createSlice({
  name: "skills",
  initialState,
  reducers: {
    addSkills(state, { payload }) {
      state.data = payload;
    },
  },
});

export const { addSkills } = skillsSlice.actions;
export default skillsSlice.reducer;
